// ----------------------------------------------------------------------
import palette from "./palette";

function pxToRem(value) {
  return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
  return {
    "@media (min-width:400px)": {
      fontSize: pxToRem(sm),
    },
    "@media (min-width:900px)": {
      fontSize: pxToRem(md),
    },
    "@media (min-width:1200px)": {
      fontSize: pxToRem(lg),
    },
  };
}

const FONT_PRIMARY = "Inria Serif, Public Sans, sans-serif";

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  hero: {
    fontWeight: "normal",
    lineHeight: 1,
    fontSize: pxToRem(50),
    color: "white",
    ...responsiveFontSizes({ sm: 70, md: 90, lg: 150 }),
  },
  heroSubtext: {
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    fontFamily: "karla",
    color: "white",
    ...responsiveFontSizes({ sm: 16, md: 20, lg: 24 }),
  },
  quote: {
    fontFamily: "karla",
    fontStyle: "italic",
    textAlign: "center",
    fontSize: "2rem",
  },
  quoteAuthor: {
    fontFamily: "karla",
    textAlign: "center",
    fontSize: "1rem",
    display: "block",
  },
  card: {
    fontSize: "2rem",
  },
  bigNumber: {
    fontSize: 50,
    ...responsiveFontSizes({ sm: 56, md: 64, lg: 74 }),
  },
  h1: {
    lineHeight: 80 / 64,
    fontSize: pxToRem(40),
    fontWeight: "normal",
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
    color: "black",
  },
  h2: {
    lineHeight: 64 / 48,
    fontWeight: "normal",
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
    color: "black",
  },
  h3: {
    fontWeight: "normal",
    lineHeight: 1.5,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
    color: "black",
  },
  h4: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 18, md: 22, lg: 22 }),
    color: "black",
  },
  h5: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
    color: "black",
  },
  h6: {
    fontWeight: 500,
    lineHeight: 28 / 18,
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
    color: "black",
  },
  subtitle1: {
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    color: "#7a8999",
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    color: "#747f8a",
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    color: palette.grey[700],
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    letterSpacing: 1.1,
    textTransform: "uppercase",
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: "capitalize",
  },
};

export default typography;
